export class DocViewerContextDoc {
	public order: number;
	public docId: string;
	public parentDocId: string;
	public docTitle: string;
	public emailTypeId: string;
	public hasChildren: boolean;
	public displayType: 'native' | 'email' | 'attachment';
	public isExpandedResult: boolean = false;
	public hasParentInView: boolean = false;
	public childLevel: number = 0;
}    

export class DocViewerContext {
	docList: DocViewerContextDoc[];
	includeEmailFamiles: boolean;
}